import { Component, inject, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ComponentNotes, ReleaseNotes, ReleaseRetrievalService } from 'src/app/services/apiHandler/release-retrieval/release-retrieval.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-release-notes',
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.scss'],
})
export class ReleaseNotesComponent implements OnInit {
    
    public line!: string;
    public releaseNotes: ReleaseNotes[] = [];
    public components!: ComponentNotes;
    public expandedArray: boolean[] = [];
    public loaded: boolean = false;
    public pdfLoading: boolean = false;
    private snackbar = inject(MatSnackBar);
    public error: boolean = false;
    public errorComp: boolean = false;
    public releasenotesHeader!: string;

    constructor(private route: ActivatedRoute, private releaseRetrievalService: ReleaseRetrievalService, public translate: TranslateService) {}

    ngOnInit(): void {
        this.route.params.subscribe({
            next: (params) => {
                this.line = params['line'];
                let index = this.line.indexOf('line');
                this.line = this.line.slice(0,index);
                this.releasenotesHeader = "RELEASENOTES." + this.line.toUpperCase();
                this.retrieveReleaseNotes();
            }
        });
    }

    private retrieveReleaseNotes() {
        this.releaseRetrievalService.getReleaseNotes(this.line).subscribe({
            next: (resp) => {
                this.releaseNotes = JSON.parse(JSON.stringify(resp.body));
                this.releaseNotes.forEach(() => {
                    this.expandedArray.push(false);
                });
            }, error: () => {
                this.error = true;
            }
        });
    }

    public toggleBtn(release: any) {
        // option when just one can be open
        for (let i = 0; i < this.expandedArray.length; i++) {
            if (i == release) {
                this.expandedArray[release] = !this.expandedArray[release];
            } else {
                this.expandedArray[i] = false;
            }
        }
        // option when more than one can be open
        //this.expandedArray[release] = !this.expandedArray[release];
    }

    public loadComponent(component: string) {
        this.loaded = false;
        this.releaseRetrievalService.getComponentNotes(component).subscribe({
            next: (resp) => {
                this.components = JSON.parse(JSON.stringify(resp.body));
                this.loaded = true;
                this.errorComp = false;
            },error: () => {
                this.loaded = true;
                this.errorComp = true;
            }
        });
    }

    public downloadAll() {
        /**
         * Loads a PDF document from the API via HTTP.
         * - Creates a blob object from the response body
         * - Creates a temporary URL from it and opens it in a new tab
         *      - This triggers the ‘Open or save’ browser dialogue
         * - Releases the generated URL again after 1 minute to avoid memory leaks
         * - Handles possible errors during the HTTP request or opening the new tab
         */
        this.pdfLoading = true;

        this.releaseRetrievalService.downloadAllNotes(this.line).subscribe({
            next: (data) => {
                /* Check if data is sent from server */
                if (!data.body) {
                    console.error('Response body is empty.');
                    this.pdfLoading = false;
                    this.setPdfErrorSnackBar();
                    return;
                }

                /* Create blob and pdf in new tab*/
                const blob = new Blob([data.body], { type: 'application/pdf' });
                const downloadURL = window.URL.createObjectURL(blob);
                const newTab = window.open(downloadURL);
                if (!newTab) {
                    console.warn('Could not open new tab, possible Pop-Up Blocker?');
                    this.setPdfErrorSnackBar();
                }

                this.pdfLoading = false;
                /* CleanUp Url after 1 minute*/
                setTimeout(() => {
                    window.URL.revokeObjectURL(downloadURL);
                }, 60000);
            },
            error: (err) => {
                console.error('Error while loading pdf:', err);
                this.pdfLoading = false;
                this.setPdfErrorSnackBar();
            },
        });
    }

    private setPdfErrorSnackBar() {
        let message = this.translate.instant('ERROR.PDF_DOWNLOAD');
        this.snackbar.open(message, '', { duration: 3000 });
    }
}
